var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSondageBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4970b6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.86,31.46h-19.86c-.5,0-.91-.41-.91-.91V10.69c0-.5.41-.91.91-.91h19.86c.5,0,.91.41.91.91v19.87c0,.5-.41.91-.91.91ZM65.9,29.65h18.05V11.6h-18.05v18.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.86,60.84h-19.86c-.5,0-.91-.41-.91-.91v-19.87c0-.5.41-.91.91-.91h19.86c.5,0,.91.41.91.91v19.87c0,.5-.41.91-.91.91ZM65.9,59.03h18.05v-18.05h-18.05v18.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.86,90.22h-19.86c-.5,0-.91-.41-.91-.91v-19.86c0-.5.41-.91.91-.91h19.86c.5,0,.91.41.91.91v19.86c0,.5-.41.91-.91.91ZM65.9,88.41h18.05v-18.05h-18.05v18.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.26,55.67c-.23,0-.46-.09-.63-.26l-8.59-8.35,1.26-1.3,7.98,7.75,22.11-20.14,1.22,1.34-22.74,20.71c-.17.16-.39.24-.61.24Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSondageBleu);
export default __webpack_public_path__ + "static/media/sondage_bleu.e31a5d54f899e8848d320800fd2c14dd.svg";
export { ForwardRef as ReactComponent };